import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { Button, Flex, Text } from "@chakra-ui/react";
import { PlanType } from "sdk/types";
import { routes } from "~/constants";
import { LogoWithCircle } from "~/icons";
import { CardContainer } from "./CardContainer";
import { CardTitle } from "./CardTitle";

interface Props {
  type: PlanType;
}

export const SelectedPlanCard: FC<Props> = ({ type }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const state = location.state || {};
  const { type: _type, ...otherState } = state;

  return (
    <CardContainer gap={3}>
      <CardTitle>{t("planPayment.yourPlan.heading")}</CardTitle>
      <Flex
        align={{ base: "flex-start", md: "center" }}
        direction={{ base: "column", md: "row" }}
        justify="space-between"
      >
        <Flex gap={2}>
          <LogoWithCircle color="th.white" />
          <Text>{t(`planPayment.planInfo.${type}.title`)}</Text>
        </Flex>
        <Flex mt={{ base: 3, md: "-2px" }}>
          <Button
            as={Link}
            color="th.signatureGreen"
            fontWeight="bold"
            h="unset"
            state={{ ...otherState }}
            size="th-mid"
            to={routes.planSelect}
            variant="th-button-text"
          >
            {t("planPayment.yourPlan.changePlanLinkText")}
          </Button>
        </Flex>
      </Flex>
    </CardContainer>
  );
};
